import { SetStateAction } from "react";

import { ALERT_STATUS } from "context/alert/types/enums";

import { ProcessSnackPackOptions, SnackbarData } from "./types";

const processSnackPack = (parameters: ProcessSnackPackOptions) => {
    const {
        status,
        snackPack,
        title,
        description,
        primaryBtn,
        secondaryBtn,
        setSnackPack,
        setIsOpen
    } = parameters;

    status
        ? setSnackPack([
              ...snackPack,
              { status, title, description, primaryBtn, secondaryBtn }
          ])
        : setIsOpen(false);
};

const processAlertData = (
    snackPack: SnackbarData[],
    alertStatus: ALERT_STATUS | null,
    isOpen: boolean,
    setAlertData: (value: SetStateAction<SnackbarData>) => void,
    setIsOpen: (value: SetStateAction<boolean>) => void
) => {
    if (snackPack.length > 0) {
        if (!alertStatus) {
            setAlertData(snackPack.shift()!);
            setIsOpen(true);
        } else if (alertStatus && isOpen) {
            setIsOpen(false);
        }
    }
};

export { processSnackPack, processAlertData };
